import StepBaseService from "../stepBase";
import StepBusinessType from "../stepBase/stepBusinessType";

class ApplyForJbStepService extends StepBaseService {
  // @ts-ignore
  getExtensionKey = () => {
    return StepBusinessType.jBStatus;
  };

  // @ts-ignore
  getTaskInfoKey = () => {
    return StepBusinessType.taskInfo;
  };

  // @ts-ignore
  getFlowStepData = () => null;
}

export default new ApplyForJbStepService();
